module.exports = __webpack_public_path__ + "img/1.5e0a4f0b.png";